import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Wall, WallEnding } from "./mdl/Wall";
import { Util } from "./utils/Util";
import { signedAngleBetweenVectors2, VECTOR2_X } from "@egr/wcf/modules/core/utils/MathUtils";
export class RoomWizard {
    static rotateRoom(pAngle) {
        RoomWizard.getRotation();
        RoomWizard.mAngle = -pAngle;
    }
    /**
     *<pre>
     * ╔═══A═══╗
     * ║       ║
     * ║       B
     * ║       ║
     * ╚═══════╝
     *</pre>
     */
    static createSquareRoom(pRoomManger, pWallHeight, pWallThickness, pLengths) {
        try {
            let tHT = pWallThickness * 0.5;
            let tHA = pLengths.a * 0.5;
            let tHB = pLengths.b * 0.5;
            let tRot = RoomWizard.getRotation();
            let tPWallAs = new Vector2(-tHA - tHT, tHB + tHT);
            let tPWallAe = new Vector2(tHA + tHT, tHB + tHT);
            let tPWallBs = tPWallAe;
            let tPWallBe = new Vector2(tHA + tHT, -tHB - tHT);
            let tPWallCs = tPWallBe;
            let tPWallCe = new Vector2(tPWallAs.x, tPWallBe.y);
            let tPWallDs = tPWallCe;
            let tPWallDe = tPWallAs;
            tPWallAs = Util.rotateVector(tPWallAs, tRot);
            tPWallAe = Util.rotateVector(tPWallAe, tRot);
            tPWallBe = Util.rotateVector(tPWallBe, tRot);
            tPWallCe = Util.rotateVector(tPWallCe, tRot);
            //pRoomManger._clear();
            pRoomManger.beginCollectWallUpdates();
            let tWallA = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallA.setStartPoint(tPWallAs);
            tWallA.setEndPoint(tPWallAe);
            tWallA.setDrawingNew(false);
            let tWallB = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallB.setStartPoint(tPWallBs);
            tWallB.setEndPoint(tPWallBe);
            tWallB._setConnection(WallEnding.Start, tWallA, WallEnding.End);
            let tWallC = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallC.setStartPoint(tPWallCs);
            tWallC.setEndPoint(tPWallCe);
            tWallC._setConnection(WallEnding.Start, tWallB, WallEnding.End);
            let tWallD = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallD.setStartPoint(tPWallDs);
            tWallD.setEndPoint(tPWallDe);
            tWallD._setConnection(WallEnding.Start, tWallC, WallEnding.End);
            tWallD._setConnection(WallEnding.End, tWallA, WallEnding.Start);
            tWallA.createDummySideWalls();
            tWallB.createDummySideWalls();
            tWallC.createDummySideWalls();
            tWallD.createDummySideWalls();
        }
        finally {
            pRoomManger.app.viewer.requestRenderFrame();
            pRoomManger.endCollectWallUpdates(true);
        }
    }
    /**
     *<pre>
     * ╔══A══╗
     * ║     ║
     * D     ╚════╗
     * ║          B
     * ╚════C═════╝
     *</pre>
     */
    static createLRoom(pRoomManger, pWallHeight, pWallThickness, pLengths) {
        try {
            let tHT = pWallThickness * 0.5;
            let tT = pWallThickness;
            let tCX = pLengths.c * 0.5;
            let tCY = pLengths.d * 0.5;
            let tE = pLengths.d - pLengths.b;
            let tF = pLengths.c - pLengths.a;
            let tRot = RoomWizard.getRotation();
            let tPWallAs = new Vector2(-tCX - tHT, tCY + tHT);
            let tPWallAe = new Vector2(-tCX + pLengths.a + tHT, tCY + tHT);
            let tPWallEs = tPWallAe;
            let tPWallEe = new Vector2(tPWallAe.x, tPWallAe.y - tE);
            let tPWallFs = tPWallEe;
            let tPWallFe = new Vector2(tPWallEe.x + tF, tPWallEe.y);
            let tPWallBs = tPWallFe;
            let tPWallBe = new Vector2(tPWallFe.x, tPWallFe.y - pLengths.b - tT);
            let tPWallCs = tPWallBe;
            let tPWallCe = new Vector2(tPWallAs.x, tPWallBe.y);
            let tPWallDs = tPWallCe;
            let tPWallDe = tPWallAs;
            tPWallAs = Util.rotateVector(tPWallAs, tRot);
            tPWallAe = Util.rotateVector(tPWallAe, tRot);
            tPWallEe = Util.rotateVector(tPWallEe, tRot);
            tPWallFe = Util.rotateVector(tPWallFe, tRot);
            tPWallBe = Util.rotateVector(tPWallBe, tRot);
            tPWallCe = Util.rotateVector(tPWallCe, tRot);
            //pRoomManger._clear();
            pRoomManger.beginCollectWallUpdates();
            let tWallA = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallA.setStartPoint(tPWallAs);
            tWallA.setEndPoint(tPWallAe);
            tWallA.setDrawingNew(false);
            let tWallE = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallE.setStartPoint(tPWallEs);
            tWallE.setEndPoint(tPWallEe);
            tWallE._setConnection(WallEnding.Start, tWallA, WallEnding.End);
            let tWallF = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallF.setStartPoint(tPWallFs);
            tWallF.setEndPoint(tPWallFe);
            tWallF._setConnection(WallEnding.Start, tWallE, WallEnding.End);
            let tWallB = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallB.setStartPoint(tPWallBs);
            tWallB.setEndPoint(tPWallBe);
            tWallB._setConnection(WallEnding.Start, tWallF, WallEnding.End);
            let tWallC = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallC.setStartPoint(tPWallCs);
            tWallC.setEndPoint(tPWallCe);
            tWallC._setConnection(WallEnding.Start, tWallB, WallEnding.End);
            let tWallD = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallD.setStartPoint(tPWallDs);
            tWallD.setEndPoint(tPWallDe);
            tWallD._setConnection(WallEnding.Start, tWallC, WallEnding.End);
            tWallD._setConnection(WallEnding.End, tWallA, WallEnding.Start);
            tWallA.createDummySideWalls();
            tWallB.createDummySideWalls();
            tWallC.createDummySideWalls();
            tWallD.createDummySideWalls();
            tWallE.createDummySideWalls();
            tWallF.createDummySideWalls();
        }
        finally {
            pRoomManger.app.viewer.requestRenderFrame();
            pRoomManger.endCollectWallUpdates(true);
        }
    }
    /**
     *<pre>
     * ╔══A══╗
     * ║      \
     * D       \
     * ║        ╗
     * ║        B
     * ╚════C═══╝
     *</pre>
     */
    static createRoomWithAngledCorner(pRoomManger, pWallHeight, pWallThickness, pLengths) {
        try {
            let tHT = pWallThickness * 0.5;
            let tT = pWallThickness;
            let tCX = pLengths.c * 0.5;
            let tCY = pLengths.d * 0.5;
            let tRot = RoomWizard.getRotation();
            let tPWallAs = new Vector2(-tCX - tHT, tCY + tHT);
            let tPWallAe = new Vector2(-tCX + pLengths.a + tHT, tCY + tHT);
            let tPWallDs = new Vector2(tPWallAs.x, tPWallAs.y - pLengths.d - tT);
            let tPWallDe = tPWallAs;
            let tPWallCe = tPWallDs;
            let tPWallCs = new Vector2(tPWallDs.x + pLengths.c + tT, tPWallDs.y);
            let tPWallBe = tPWallCs;
            let tPWallBs = new Vector2(tPWallBe.x, tPWallBe.y + pLengths.b);
            let tPWallEs = tPWallAe;
            let tPWallEe = tPWallBs;
            tPWallAs = Util.rotateVector(tPWallAs, tRot);
            tPWallAe = Util.rotateVector(tPWallAe, tRot);
            tPWallEe = Util.rotateVector(tPWallEe, tRot);
            tPWallBe = Util.rotateVector(tPWallBe, tRot);
            tPWallCe = Util.rotateVector(tPWallCe, tRot);
            //pRoomManger._clear();
            pRoomManger.beginCollectWallUpdates();
            let tWallA = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallA.setStartPoint(tPWallAs);
            tWallA.setEndPoint(tPWallAe);
            tWallA.setDrawingNew(false);
            let tWallE = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallE.setStartPoint(tPWallEs);
            tWallE.setEndPoint(tPWallEe);
            tWallE._setConnection(WallEnding.Start, tWallA, WallEnding.End);
            let tWallB = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallB.setStartPoint(tPWallBs);
            tWallB.setEndPoint(tPWallBe);
            tWallB._setConnection(WallEnding.Start, tWallE, WallEnding.End);
            let tWallC = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallC.setStartPoint(tPWallCs);
            tWallC.setEndPoint(tPWallCe);
            tWallC._setConnection(WallEnding.Start, tWallB, WallEnding.End);
            let tWallD = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallD.setStartPoint(tPWallDs);
            tWallD.setEndPoint(tPWallDe);
            tWallD._setConnection(WallEnding.Start, tWallC, WallEnding.End);
            tWallD._setConnection(WallEnding.End, tWallA, WallEnding.Start);
            tWallA.createDummySideWalls();
            tWallB.createDummySideWalls();
            tWallC.createDummySideWalls();
            tWallD.createDummySideWalls();
            tWallE.createDummySideWalls();
        }
        finally {
            pRoomManger.app.viewer.requestRenderFrame();
            pRoomManger.endCollectWallUpdates(true);
        }
    }
    /**
     *<pre>
     * ╔═════════A═════════╗
     * ║                   B
     * ╚══E══╗       ╔══C══╝
     *       ║       D
     *       ╚═══════╝
     *</pre>
     */
    static createTRoom(pRoomManger, pWallHeight, pWallThickness, pLengths) {
        try {
            let tHT = pWallThickness * 0.5;
            let tT = pWallThickness;
            let tCX = pLengths.a * 0.5;
            let tCY = (pLengths.b + pLengths.d) * 0.5;
            let tF = pLengths.a - pLengths.c - pLengths.e;
            let tRot = RoomWizard.getRotation();
            let tPWallAs = new Vector2(-tCX - tHT, tCY + tHT);
            let tPWallAe = new Vector2(-tCX + pLengths.a + tHT, tCY + tHT);
            let tPWallBs = tPWallAe;
            let tPWallBe = new Vector2(tPWallAe.x, tPWallAe.y - pLengths.b - tT);
            let tPWallCs = tPWallBe;
            let tPWallCe = new Vector2(tPWallBs.x - pLengths.c, tPWallBe.y);
            let tPWallDs = tPWallCe;
            let tPWallDe = new Vector2(tPWallCe.x, tPWallCe.y - pLengths.d);
            let tPWallFs = tPWallDe;
            let tPWallFe = new Vector2(tPWallDs.x - tF - tT, tPWallDe.y);
            let tPWallGs = tPWallFe;
            let tPWallGe = new Vector2(tPWallFe.x, tPWallCe.y);
            let tPWallEs = tPWallGe;
            let tPWallEe = new Vector2(tPWallAs.x, tPWallCs.y);
            let tPWallHs = tPWallEe;
            let tPWallHe = tPWallAs;
            tPWallAs = Util.rotateVector(tPWallAs, tRot);
            tPWallAe = Util.rotateVector(tPWallAe, tRot);
            tPWallBe = Util.rotateVector(tPWallBe, tRot);
            tPWallCe = Util.rotateVector(tPWallCe, tRot);
            tPWallDe = Util.rotateVector(tPWallDe, tRot);
            tPWallFe = Util.rotateVector(tPWallFe, tRot);
            tPWallGe = Util.rotateVector(tPWallGe, tRot);
            tPWallEe = Util.rotateVector(tPWallEe, tRot);
            //pRoomManger._clear();
            pRoomManger.beginCollectWallUpdates();
            let tWallA = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallA.setStartPoint(tPWallAs);
            tWallA.setEndPoint(tPWallAe);
            tWallA.setDrawingNew(false);
            let tWallB = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallB.setStartPoint(tPWallBs);
            tWallB.setEndPoint(tPWallBe);
            tWallB._setConnection(WallEnding.Start, tWallA, WallEnding.End);
            let tWallC = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallC.setStartPoint(tPWallCs);
            tWallC.setEndPoint(tPWallCe);
            tWallC._setConnection(WallEnding.Start, tWallB, WallEnding.End);
            let tWallD = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallD.setStartPoint(tPWallDs);
            tWallD.setEndPoint(tPWallDe);
            tWallD._setConnection(WallEnding.Start, tWallC, WallEnding.End);
            let tWallF = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallF.setStartPoint(tPWallFs);
            tWallF.setEndPoint(tPWallFe);
            tWallF._setConnection(WallEnding.Start, tWallD, WallEnding.End);
            let tWallG = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallG.setStartPoint(tPWallGs);
            tWallG.setEndPoint(tPWallGe);
            tWallG._setConnection(WallEnding.Start, tWallF, WallEnding.End);
            let tWallE = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallE.setStartPoint(tPWallEs);
            tWallE.setEndPoint(tPWallEe);
            tWallE._setConnection(WallEnding.Start, tWallG, WallEnding.End);
            let tWallH = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallH.setStartPoint(tPWallHs);
            tWallH.setEndPoint(tPWallHe);
            tWallH._setConnection(WallEnding.Start, tWallE, WallEnding.End);
            tWallH._setConnection(WallEnding.End, tWallA, WallEnding.Start);
            tWallA.createDummySideWalls();
            tWallB.createDummySideWalls();
            tWallC.createDummySideWalls();
            tWallD.createDummySideWalls();
            tWallE.createDummySideWalls();
            tWallF.createDummySideWalls();
            tWallG.createDummySideWalls();
            tWallH.createDummySideWalls();
        }
        finally {
            pRoomManger.app.viewer.requestRenderFrame();
            pRoomManger.endCollectWallUpdates(true);
        }
    }
    /**
     *<pre>
     * ╔═══════A══════╗
     * ║              ║
     * ║              ║
     * ╚═══╗          B
     *     ║          ║
     *     ║          ╚═C═╗
     *     ║              D
     *     ║              ║
     *     ╚══════════════╝
     *</pre>
     */
    static createZRoom(pRoomManger, pWallHeight, pWallThickness, pLengths) {
        try {
            let tHT = pWallThickness * 0.5;
            let tT = pWallThickness;
            let tCX = (pLengths.a + pLengths.c) * 0.5;
            let tCY = (pLengths.b + pLengths.d) * 0.5;
            let tF = pLengths.a - pLengths.c;
            let tRot = RoomWizard.getRotation();
            let tPWallAs = new Vector2(-tCX - tHT, tCY + tHT);
            let tPWallAe = new Vector2(-tCX + pLengths.a + tHT, tCY + tHT);
            let tPWallBs = tPWallAe;
            let tPWallBe = new Vector2(tPWallAe.x, tPWallAe.y - pLengths.b);
            let tPWallCs = tPWallBe;
            let tPWallCe = new Vector2(tPWallBs.x + pLengths.c, tPWallBe.y);
            let tPWallDs = tPWallCe;
            let tPWallDe = new Vector2(tPWallCe.x, tPWallCe.y - pLengths.d - tT);
            let tPWallEs = tPWallDe;
            let tPWallEe = new Vector2(tPWallDs.x - pLengths.a - tT, tPWallDe.y);
            let tPWallFs = tPWallEe;
            let tPWallFe = new Vector2(tPWallEe.x, tPWallEe.y + pLengths.b);
            let tPWallGs = tPWallFe;
            let tPWallGe = new Vector2(tPWallAs.x, tPWallFe.y);
            let tPWallHs = tPWallGe;
            let tPWallHe = tPWallAs;
            tPWallAs = Util.rotateVector(tPWallAs, tRot);
            tPWallAe = Util.rotateVector(tPWallAe, tRot);
            tPWallBe = Util.rotateVector(tPWallBe, tRot);
            tPWallCe = Util.rotateVector(tPWallCe, tRot);
            tPWallDe = Util.rotateVector(tPWallDe, tRot);
            tPWallEe = Util.rotateVector(tPWallEe, tRot);
            tPWallFe = Util.rotateVector(tPWallFe, tRot);
            tPWallGe = Util.rotateVector(tPWallGe, tRot);
            //pRoomManger._clear();
            pRoomManger.beginCollectWallUpdates();
            let tWallA = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallA.setStartPoint(tPWallAs);
            tWallA.setEndPoint(tPWallAe);
            tWallA.setDrawingNew(false);
            let tWallB = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallB.setStartPoint(tPWallBs);
            tWallB.setEndPoint(tPWallBe);
            tWallB._setConnection(WallEnding.Start, tWallA, WallEnding.End);
            let tWallC = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallC.setStartPoint(tPWallCs);
            tWallC.setEndPoint(tPWallCe);
            tWallC._setConnection(WallEnding.Start, tWallB, WallEnding.End);
            let tWallD = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallD.setStartPoint(tPWallDs);
            tWallD.setEndPoint(tPWallDe);
            tWallD._setConnection(WallEnding.Start, tWallC, WallEnding.End);
            let tWallF = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallF.setStartPoint(tPWallEs);
            tWallF.setEndPoint(tPWallEe);
            tWallF._setConnection(WallEnding.Start, tWallD, WallEnding.End);
            let tWallG = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallG.setStartPoint(tPWallFs);
            tWallG.setEndPoint(tPWallFe);
            tWallG._setConnection(WallEnding.Start, tWallF, WallEnding.End);
            let tWallE = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallE.setStartPoint(tPWallGs);
            tWallE.setEndPoint(tPWallGe);
            tWallE._setConnection(WallEnding.Start, tWallG, WallEnding.End);
            let tWallH = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallH.setStartPoint(tPWallHs);
            tWallH.setEndPoint(tPWallHe);
            tWallH._setConnection(WallEnding.Start, tWallE, WallEnding.End);
            tWallH._setConnection(WallEnding.End, tWallA, WallEnding.Start);
            tWallA.createDummySideWalls();
            tWallB.createDummySideWalls();
            tWallC.createDummySideWalls();
            tWallD.createDummySideWalls();
            tWallE.createDummySideWalls();
            tWallF.createDummySideWalls();
            tWallG.createDummySideWalls();
            tWallH.createDummySideWalls();
        }
        finally {
            pRoomManger.app.viewer.requestRenderFrame();
            pRoomManger.endCollectWallUpdates(true);
        }
    }
    /**
     *<pre>
     *     ╔═══════A══════╗
     *     ║              B
     *     ║              ║
     *     ║          ╔═C═╝
     *     ║          ║
     * ╔═══╝          ║
     * ║              D
     * ║              ║
     * ╚══════════════╝
     *</pre>
     */
    static createSRoom(pRoomManger, pWallHeight, pWallThickness, pLengths) {
        try {
            let tHT = pWallThickness * 0.5;
            let tT = pWallThickness;
            let tCX = (pLengths.a + pLengths.c) * 0.5;
            let tCY = (pLengths.b + pLengths.d) * 0.5;
            let tF = pLengths.a - pLengths.c;
            let tRot = RoomWizard.getRotation();
            let tPWallAs = new Vector2(tCX - tHT - pLengths.a, tCY + tHT);
            let tPWallAe = new Vector2(tCX + tHT, tCY + tHT);
            let tPWallBs = tPWallAe;
            let tPWallBe = new Vector2(tPWallAe.x, tPWallAe.y - pLengths.b - tT);
            let tPWallCs = tPWallBe;
            let tPWallCe = new Vector2(tPWallBs.x - pLengths.c, tPWallBe.y);
            let tPWallDs = tPWallCe;
            let tPWallDe = new Vector2(tPWallCe.x, tPWallCe.y - pLengths.d);
            let tPWallEs = tPWallDe;
            let tPWallEe = new Vector2(tPWallDs.x - pLengths.a - tT, tPWallDe.y);
            let tPWallFs = tPWallEe;
            let tPWallFe = new Vector2(tPWallEe.x, tPWallEe.y + pLengths.b + tT);
            let tPWallGs = tPWallFe;
            let tPWallGe = new Vector2(tPWallAs.x, tPWallFe.y);
            let tPWallHs = tPWallGe;
            let tPWallHe = tPWallAs;
            tPWallAs = Util.rotateVector(tPWallAs, tRot);
            tPWallAe = Util.rotateVector(tPWallAe, tRot);
            tPWallBe = Util.rotateVector(tPWallBe, tRot);
            tPWallCe = Util.rotateVector(tPWallCe, tRot);
            tPWallDe = Util.rotateVector(tPWallDe, tRot);
            tPWallEe = Util.rotateVector(tPWallEe, tRot);
            tPWallFe = Util.rotateVector(tPWallFe, tRot);
            tPWallGe = Util.rotateVector(tPWallGe, tRot);
            //pRoomManger._clear();
            pRoomManger.beginCollectWallUpdates();
            let tWallA = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallA.setStartPoint(tPWallAs);
            tWallA.setEndPoint(tPWallAe);
            tWallA.setDrawingNew(false);
            let tWallB = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallB.setStartPoint(tPWallBs);
            tWallB.setEndPoint(tPWallBe);
            tWallB._setConnection(WallEnding.Start, tWallA, WallEnding.End);
            let tWallC = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallC.setStartPoint(tPWallCs);
            tWallC.setEndPoint(tPWallCe);
            tWallC._setConnection(WallEnding.Start, tWallB, WallEnding.End);
            let tWallD = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallD.setStartPoint(tPWallDs);
            tWallD.setEndPoint(tPWallDe);
            tWallD._setConnection(WallEnding.Start, tWallC, WallEnding.End);
            let tWallF = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallF.setStartPoint(tPWallEs);
            tWallF.setEndPoint(tPWallEe);
            tWallF._setConnection(WallEnding.Start, tWallD, WallEnding.End);
            let tWallG = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallG.setStartPoint(tPWallFs);
            tWallG.setEndPoint(tPWallFe);
            tWallG._setConnection(WallEnding.Start, tWallF, WallEnding.End);
            let tWallE = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallE.setStartPoint(tPWallGs);
            tWallE.setEndPoint(tPWallGe);
            tWallE._setConnection(WallEnding.Start, tWallG, WallEnding.End);
            let tWallH = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallH.setStartPoint(tPWallHs);
            tWallH.setEndPoint(tPWallHe);
            tWallH._setConnection(WallEnding.Start, tWallE, WallEnding.End);
            tWallH._setConnection(WallEnding.End, tWallA, WallEnding.Start);
            tWallA.createDummySideWalls();
            tWallB.createDummySideWalls();
            tWallC.createDummySideWalls();
            tWallD.createDummySideWalls();
            tWallE.createDummySideWalls();
            tWallF.createDummySideWalls();
            tWallG.createDummySideWalls();
            tWallH.createDummySideWalls();
        }
        finally {
            pRoomManger.app.viewer.requestRenderFrame();
            pRoomManger.endCollectWallUpdates(true);
        }
    }
    /**
     *<pre>
     * ╔══A══╗       ╔══C══╗
     * ║     B       ║     ║
     * ║     ╚═══════╝     D
     * ║                   ║
     * ╚═════════E═════════╝
     *</pre>
     */
    static createURoom(pRoomManger, pWallHeight, pWallThickness, pLengths) {
        try {
            let tHT = pWallThickness * 0.5;
            let tT = pWallThickness;
            let tCX = pLengths.e * 0.5;
            let tCY = pLengths.d * 0.5;
            let tF = pLengths.e - pLengths.a - pLengths.c;
            let tRot = RoomWizard.getRotation();
            let tPWallAs = new Vector2(-tCX - tHT, tCY + tHT);
            let tPWallAe = new Vector2(-tCX + pLengths.a + tHT, tCY + tHT);
            let tPWallBs = tPWallAe;
            let tPWallBe = new Vector2(tPWallAe.x, tPWallAe.y - pLengths.b);
            let tPWallFs = tPWallBe;
            let tPWallFe = new Vector2(tPWallBe.x + tF - tT, tPWallBe.y);
            let tPWallGs = tPWallFe;
            let tPWallGe = new Vector2(tPWallFe.x, tPWallFe.y + pLengths.b);
            let tPWallCs = tPWallGe;
            let tPWallCe = new Vector2(tPWallGs.x + pLengths.c + tT, tPWallGe.y);
            let tPWallDs = tPWallCe;
            let tPWallDe = new Vector2(tPWallCe.x, tPWallCe.y - pLengths.d - tT);
            let tPWallEs = tPWallDe;
            let tPWallEe = new Vector2(tPWallAs.x, tPWallDe.y);
            let tPWallHs = tPWallEe;
            let tPWallHe = tPWallAs;
            tPWallAs = Util.rotateVector(tPWallAs, tRot);
            tPWallAe = Util.rotateVector(tPWallAe, tRot);
            tPWallBe = Util.rotateVector(tPWallBe, tRot);
            tPWallFe = Util.rotateVector(tPWallFe, tRot);
            tPWallGe = Util.rotateVector(tPWallGe, tRot);
            tPWallCe = Util.rotateVector(tPWallCe, tRot);
            tPWallDe = Util.rotateVector(tPWallDe, tRot);
            tPWallEe = Util.rotateVector(tPWallEe, tRot);
            // pRoomManger._clear();
            pRoomManger.beginCollectWallUpdates();
            let tWallA = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallA.setStartPoint(tPWallAs);
            tWallA.setEndPoint(tPWallAe);
            tWallA.setDrawingNew(false);
            let tWallB = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallB.setStartPoint(tPWallBs);
            tWallB.setEndPoint(tPWallBe);
            tWallB._setConnection(WallEnding.Start, tWallA, WallEnding.End);
            let tWallF = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallF.setStartPoint(tPWallFs);
            tWallF.setEndPoint(tPWallFe);
            tWallF._setConnection(WallEnding.Start, tWallB, WallEnding.End);
            let tWallG = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallG.setStartPoint(tPWallGs);
            tWallG.setEndPoint(tPWallGe);
            tWallG._setConnection(WallEnding.Start, tWallF, WallEnding.End);
            let tWallC = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallC.setStartPoint(tPWallCs);
            tWallC.setEndPoint(tPWallCe);
            tWallC._setConnection(WallEnding.Start, tWallG, WallEnding.End);
            let tWallD = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallD.setStartPoint(tPWallDs);
            tWallD.setEndPoint(tPWallDe);
            tWallD._setConnection(WallEnding.Start, tWallC, WallEnding.End);
            let tWallE = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallE.setStartPoint(tPWallEs);
            tWallE.setEndPoint(tPWallEe);
            tWallE._setConnection(WallEnding.Start, tWallD, WallEnding.End);
            let tWallH = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallH.setStartPoint(tPWallHs);
            tWallH.setEndPoint(tPWallHe);
            tWallH._setConnection(WallEnding.Start, tWallE, WallEnding.End);
            tWallH._setConnection(WallEnding.End, tWallA, WallEnding.Start);
            tWallA.createDummySideWalls();
            tWallB.createDummySideWalls();
            tWallC.createDummySideWalls();
            tWallD.createDummySideWalls();
            tWallE.createDummySideWalls();
            tWallF.createDummySideWalls();
            tWallG.createDummySideWalls();
            tWallH.createDummySideWalls();
        }
        finally {
            pRoomManger.app.viewer.requestRenderFrame();
            pRoomManger.endCollectWallUpdates(true);
        }
    }
    /**
     *<pre>
     * ╔═══B═══
     * ║
     * A
     * ║
     *</pre>
     */
    static createCorner(pRoomManger, pWallHeight, pWallThickness, pLengths) {
        try {
            let tHT = pWallThickness * 0.5;
            let tHA = pLengths.a * 0.5;
            let tHB = pLengths.b * 0.5;
            let tRot = RoomWizard.getRotation();
            let tPWallAs = new Vector2(-tHA - tHT, -tHB);
            let tPWallAe = new Vector2(-tHA - tHT, tHB + tHT);
            let tPWallBs = tPWallAe;
            let tPWallBe = new Vector2(tHA, tHB + tHT);
            tPWallAs = Util.rotateVector(tPWallAs, tRot);
            tPWallAe = Util.rotateVector(tPWallAe, tRot);
            tPWallBe = Util.rotateVector(tPWallBe, tRot);
            // pRoomManger._clear();
            pRoomManger.beginCollectWallUpdates();
            let tWallA = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallA.setStartPoint(tPWallAs);
            tWallA.setEndPoint(tPWallAe);
            tWallA.setDrawingNew(false);
            let tWallB = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
            tWallB.setStartPoint(tPWallBs);
            tWallB.setEndPoint(tPWallBe);
            tWallB._setConnection(WallEnding.Start, tWallA, WallEnding.End);
            tWallA.createDummySideWalls();
            tWallB.createDummySideWalls();
        }
        finally {
            pRoomManger.app.viewer.requestRenderFrame();
            pRoomManger.endCollectWallUpdates(true);
        }
    }
    /**
     *<pre>
     * Creates room based on point array
     * For a closed room, the last point has to be the same as the first one.
     *</pre>
     */
    static polygonRoom(pRoomManger, pWallHeight, pWallThickness, pEdges) {
        if (pEdges.length < 2)
            return (null);
        let tEdges = Util.to2dArray(Util.centerPolygon(Util.to3dArray(pEdges)));
        let tWalls = Array();
        let tLines = new Array();
        let trotAngle = RoomWizard.getRotation();
        let tRot = RoomWizard.getRotation();
        let tarWallRot = {};
        tarWallRot.walls = new Array();
        try {
            let tHT = pWallThickness * 0.5;
            let tfirstWall = tEdges[1].subtract(tEdges[0]);
            let trotRad = signedAngleBetweenVectors2(VECTOR2_X, tfirstWall);
            trotAngle = trotRad / (Math.PI / 180);
            tarWallRot.angle = trotAngle;
            // pRoomManger._clear();
            pRoomManger.beginCollectWallUpdates();
            // create line system
            for (let i = 0; i < tEdges.length - 1; i++) {
                let tLine = new Array();
                let tStart = tEdges[i];
                let tEnd = tEdges[i + 1];
                if (i == 0)
                    tStart = Util.rotateVector(tStart, -trotAngle);
                tEnd = Util.rotateVector(tEnd, -trotAngle);
                tLine.push(tStart);
                tLine.push(tEnd);
                tLines.push(tLine);
                tarWallRot.walls.push([Util.to3d(tStart), Util.to3d(tEnd)]);
            }
            tLines[0][0] = Util.rotateVector(tLines[0][0], tRot);
            tLines[0][1] = Util.rotateVector(tLines[0][1], tRot);
            for (let i = 1; i < tLines.length; i++) {
                let tLine = tLines[i];
                tLine[1] = Util.rotateVector(tLine[1], tRot);
            }
            for (let i = 0; i < tLines.length; i++) {
                let tLine = tLines[i];
                let tWall = RoomWizard.createWall(pRoomManger, pWallHeight, pWallThickness);
                tWall.setStartPoint(tLine[0]);
                tWall.setEndPoint(tLine[1]);
                tWalls.push(tWall);
                if (i > 0) {
                    tWall._setConnection(WallEnding.Start, tWalls[i - 1], WallEnding.End);
                }
                if (i == tLines.length - 1) {
                    tWall._setConnection(WallEnding.End, tWalls[0], WallEnding.Start);
                }
            }
        }
        finally {
            pRoomManger.app.viewer.requestRenderFrame();
            pRoomManger.endCollectWallUpdates(true);
        }
        return (tarWallRot);
    }
    static createWall(pRoomManger, pWallHeight, pWallThickness) {
        let tWall = new Wall(pRoomManger);
        tWall.setDrawingNew(true);
        tWall.setHeight(pWallHeight);
        tWall.setThickness(pWallThickness);
        pRoomManger.app.model.addElement(tWall);
        return (tWall);
    }
    static getRotation() {
        if (this.mAngle == null)
            this.mAngle = 0;
        return this.mAngle;
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
RoomWizard.mAngle = 0;
